import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/img/icon/dollar-outline-grey.svg'


const _hoisted_1 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"0px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_2 = { class: "text-2xl font-bold" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: ""
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text base font-semibold mb-4" }, "Spesifikasi Item", -1)
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { class: "lg:flex items-center gap-4 mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal required lg:w-1/5" }, "Nama Item", -1)
const _hoisted_10 = { class: "lg:w-4/5" }
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { class: "lg:flex items-center gap-4 mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal required lg:w-1/5" }, "Trayek", -1)
const _hoisted_14 = { class: "lg:w-4/5" }
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = {
  key: 0,
  class: "lg:flex items-center gap-4 mb-3"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal lg:w-1/5" }, "Kelas", -1)
const _hoisted_18 = { class: "lg:w-4/5" }
const _hoisted_19 = { class: "text-base font-normal" }
const _hoisted_20 = { class: "lg:flex items-center gap-4 mb-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal required lg:w-1/5" }, "Rute", -1)
const _hoisted_22 = { class: "lg:w-4/5" }
const _hoisted_23 = { class: "flex items-center gap-3" }
const _hoisted_24 = { class: "lg:w-4/5" }
const _hoisted_25 = { class: "w-1/5 flex items-center gap-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal required" }, "Pulang Pergi?", -1)
const _hoisted_27 = { class: "invalid-feedback" }
const _hoisted_28 = { class: "lg:flex items-center gap-4 mb-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal required lg:w-1/5" }, "Jenis Penumpang", -1)
const _hoisted_30 = { class: "lg:w-4/5" }
const _hoisted_31 = { class: "invalid-feedback" }
const _hoisted_32 = { class: "lg:flex items-center gap-4 mb-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal required lg:w-1/5" }, "Terminal Asal - Tujuan", -1)
const _hoisted_34 = { class: "lg:w-4/5" }
const _hoisted_35 = { class: "lg:flex items-center gap-3 w-full" }
const _hoisted_36 = { class: "w-2/5" }
const _hoisted_37 = { class: "invalid-feedback" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right" })
], -1)
const _hoisted_39 = { class: "w-2/5" }
const _hoisted_40 = { class: "invalid-feedback" }
const _hoisted_41 = { class: "lg:flex items-center gap-4 mb-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal required lg:w-1/5" }, "Jumlah Item", -1)
const _hoisted_43 = { class: "lg:w-4/5" }
const _hoisted_44 = { class: "p-inputgroup flex-1" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Item", -1)
const _hoisted_46 = { class: "invalid-feedback" }
const _hoisted_47 = {
  key: 0,
  class: "mt-40px"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", null, "Harga Item", -1)
const _hoisted_49 = { class: "p-3 rounded-lg border-grey-3 mt-3" }
const _hoisted_50 = { class: "flex items-center gap-4 mb-2" }
const _hoisted_51 = { class: "w-1/4 pr-3 flex items-center gap-2" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right-arrow-left text-xs text-grey" })
], -1)
const _hoisted_53 = { class: "text-xs text-grey font-semibold" }
const _hoisted_54 = { class: "w-3/4 border-left-grey-3 pl-3 flex items-center gap-2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "price"
  })
], -1)
const _hoisted_56 = { class: "text-xs text-grey font-semibold" }
const _hoisted_57 = {
  key: 0,
  class: "w-1/2 p-2 rounded-lg border-grey-3 flex items-center"
}
const _hoisted_58 = { class: "w-1/4 pr-3 flex items-center gap-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right-arrow-left text-xs text-grey" })
], -1)
const _hoisted_60 = { class: "text-xs text-grey font-semibold" }
const _hoisted_61 = { class: "w-3/4 border-left-grey-3 pl-3 flex items-center gap-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "price"
  })
], -1)
const _hoisted_63 = { class: "text-xs text-grey font-semibold" }
const _hoisted_64 = {
  key: 0,
  class: "mb-4 text-xs text-red"
}
const _hoisted_65 = { class: "mb-4 flex gap-4" }
const _hoisted_66 = { class: "md:w-1/2" }
const _hoisted_67 = { class: "mt-20px border-grey-4-dashed rounded-lg p-2" }
const _hoisted_68 = { class: "md:w-1/2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Harga Jual (sesuai jumlah karcis yang dijual)", -1)
const _hoisted_70 = { class: "p-inputgroup flex-1" }
const _hoisted_71 = { class: "p-inputgroup-addon" }
const _hoisted_72 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_73 = { class: "flex items-center gap-3 justify-end mt-40px" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Simpan")

import { toRefs, onMounted, ref, getCurrentInstance, watch } from 'vue'
import Dialog from 'primevue/dialog'
import InputSwitch from 'primevue/inputswitch'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import InputText from 'primevue/inputtext'
import { Form, Field, configure } from 'vee-validate'
import * as Yup from 'yup'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import InputNumber from 'primevue/inputnumber'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import apiUseCase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { useRoute } from 'vue-router'
import { isNull } from 'lodash'
import rgxExp from '@/utils/helpers/regExp'


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemForm',
  props: {
  show: {
    type: Boolean,
    default: false
  },
  index: {
    default: null as any
  },
  dataItem: {
    default: null as any
  },
  itemList: {
    default: [] as any
  }
},
  emits: ["hideDialog", "refreshHeader", "onSubmitAct"],
  setup(__props, { emit }: { emit: ({
  (e: 'hideDialog'): void
  (e: 'refreshHeader'): void
  (e: 'onSubmitAct', data: any, index: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const trayekEndpoint = 'management/v2/Trayeks'
const detailPriceEndpoint = 'management/v1/MsDetilPrice'
const bundleEndpoint = 'ticket/v1/Bundles'
const {
  show,
  index,
  dataItem,
  itemList
} = toRefs(props)
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
configure({
  validateOnBlur: false,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false,
})
const store = useStore()
const route = useRoute()
const showModal = show.value
const idPrams = ref(null) as any
const isPp = ref(false)
const trayekDetail = ref(null) as any
const rit1Price = ref(null) as any
const rit2Price = ref(null) as any
const isLoading = ref(false)
const isLoadingDetail = ref(true)
const isPpPriceNotMatch = ref(false)
const totalOriginalPrice = ref(0)
const tempDiscount = ref(0)
const title = ref('Tambah')

const initialValues = ref({
  Id: null as any,
  Name: '',
  Trayek: null as any,
  Route: null as any,
  PassengerType: null as any,
  OriginTerminal: null as any,
  DestinationTerminal: null as any,
  TicketsSold: 0,
  TotalTicketPrice: 0
})

const schema = Yup.object().shape({
  Name: Yup.string().required('Nama Item harus diisi')
    .min(3, 'Nama Item minimal 3 karakter')
    .max(50, 'Nama Item maksimal 50 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Item tidak boleh hanya menggunakan spasi')
    .test('unique-name', 'Nama Item sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const filterResult = itemList?.value.filter((x: any) => x.DisplayName === val && x.Id !== dataItem?.value.Id)
        if (route.params.id) {
          return filterResult.length === 0 || val === initialValues.value.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Trayek: Yup.object().typeError('Trayek harus diisi').required('Trayek harus diisi'),
  Route: Yup.object().typeError('Rute harus diisi').required('Rute harus diisi'),
  PassengerType: Yup.object().typeError('Jenis Penumpang harus diisi').required('Jenis Penumpang harus diisi'),
  OriginTerminal: Yup.object().typeError('Kota Asal harus diisi').required('Kota Asal harus diisi'),
  DestinationTerminal: Yup.object().typeError('Kota Tujuan harus diisi').required('Kota Tujuan harus diisi'),
  TicketsSold: Yup.number().required('Jumlah Karcis harus diisi').moreThan(0, 'Jumlah Karcis tidak boleh 0').lessThan(100000, 'Jumlah Karcis minimal 5 karakter'),
  TotalTicketPrice: Yup.number().required('Harga Jual harus diisi').moreThan(100, 'Harga Jual tidak boleh 0 dan minimal 3 karakter')
})

const closeDialog = () => {
  emit('hideDialog')
}

const changeIsPp = () => {
  isPp.value = !isPp.value
}

const onSubmitForEdit = async (payload: any) => {
  store.dispatch('showLoading')
  await apiOpenUseCase.postOrPut(`${bundleEndpoint}/${idPrams.value?.Id}/Items`, payload?.Id ?? null, payload).then((response) => {
    const { error, message } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: `Item berhasil ${payload.Id ? 'diubah' : 'ditambahkan'}`,
        group: 'bc',
        closable: false,
        life: 3000
      })
      closeDialog()
      emit('refreshHeader')
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Gagal!',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const onSubmit = (values: any) => {
  if (isPpPriceNotMatch.value) {
    $toast.add({
      severity: 'error',
      detail: 'Harga Normal PP tidak sama. Silahkan Periksa kembali',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else if (tempDiscount.value < 0) {
    $toast.add({
      severity: 'error',
      detail: 'Harga Jual harus lebih kecil dari (Harga Normal x Jumlah Karcis)',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else if (rit1Price.value?.Bruto < 1) {
    $toast.add({
      severity: 'error',
      detail: 'Rute dan Jenis Penumpang yang anda pilih belum memiliki harga',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    let obj = null as any
    if (idPrams.value) {
      obj = {
        Id: values.Id,
        IsPp: isPp.value,
        BundleItemType: 'Bus',
        DisplayName: values.Name ?? '-',
        Quantity: values.TicketsSold ?? 0,
        OriginalPrice: (rit1Price.value?.Bruto ?? 0) * values.TicketsSold,
        BundlePrice: values.TotalTicketPrice ?? 0,
        TotalDiscount: tempDiscount.value,
        IsActive: true,
        // TrayekDetail: trayekDetail.value,
        BundleItemSnack: null,
        BundleItemVoucher: null,
        BundleItemRoutes: [{
          TrayekId: values.Trayek?.Id,
          TrayekName: values.Trayek?.Name,
          RouteId: values.Route?.MsRouteId,
          RouteName: values.Route?.MsRouteName,
          // RouteDetails: values.Route.RouteDetails,
          ClassId: values.Trayek?.MsClassId,
          ClassName: values.Trayek?.MsClassName,
          PassengerTypeId: values.PassengerType?.Id,
          PassengerTypeName: values.PassengerType?.Name,
          OriginStationId: values.OriginTerminal?.MsStationId,
          OriginStationCode: values.OriginTerminal?.MsStationCode,
          OriginStationName: values.OriginTerminal?.MsStationName,
          OriginCityId: values.OriginTerminal?.MsCityId,
          OriginCityCode: values.OriginTerminal?.MsCityCode,
          OriginCityName: values.OriginTerminal?.MsCityName,
          DestinationStationId: values.DestinationTerminal?.MsStationId,
          DestinationStationCode: values.DestinationTerminal?.MsStationCode,
          DestinationStationName: values.DestinationTerminal?.MsStationName,
          DestinationCityId: values.DestinationTerminal?.MsCityId,
          DestinationCityCode: values.DestinationTerminal?.MsCityCode,
          DestinationCityName: values.DestinationTerminal?.MsCityName
        }]
      }
      if (isPp.value) {
        obj.BundleItemRoutes.push({
          TrayekId: values.Trayek?.Id,
          TrayekName: values.Trayek?.Name,
          RouteId: values.Route?.MsRouteId,
          RouteName: values.Route?.MsRouteName,
          // RouteDetails: values.Route?.RouteDetails,
          ClassId: values.Trayek?.MsClassId,
          ClassName: values.Trayek?.MsClassName,
          PassengerTypeId: values.PassengerType?.Id,
          PassengerTypeName: values.PassengerType?.Name,
          OriginStationId: values.DestinationTerminal?.MsStationId,
          OriginStationCode: values.DestinationTerminal?.MsStationCode,
          OriginStationName: values.DestinationTerminal?.MsStationName,
          OriginCityId: values.DestinationTerminal?.MsCityId,
          OriginCityCode: values.DestinationTerminal?.MsCityCode,
          OriginCityName: values.DestinationTerminal?.MsCityName,
          DestinationStationId: values.OriginTerminal?.MsStationId,
          DestinationStationCode: values.OriginTerminal?.MsStationCode,
          DestinationStationName: values.OriginTerminal?.MsStationName,
          DestinationCityId: values.OriginTerminal?.MsCityId,
          DestinationCityCode: values.OriginTerminal?.MsCityCode,
          DestinationCityName: values.OriginTerminal?.MsCityName
        })
      }
      onSubmitForEdit(obj)
    } else {
      obj = {
        Id: values.Id,
        IsPp: isPp.value,
        BundleItemType: 'Bus',
        DisplayName: values.Name ?? '-',
        Quantity: values.TicketsSold ?? 0,
        OriginalPrice: (rit1Price.value?.Bruto ?? 0) * values.TicketsSold,
        BundlePrice: values.TotalTicketPrice ?? 0,
        TotalDiscount: tempDiscount.value,
        IsActive: true,
        TrayekDetail: trayekDetail.value,
        BundleItemRoutes: [{
          TrayekId: values.Trayek?.Id,
          TrayekName: values.Trayek?.Name,
          RouteId: values.Route?.MsRouteId,
          RouteName: values.Route?.MsRouteName,
          // RouteDetails: values.Route.RouteDetails,
          ClassId: values.Trayek?.MsClassId,
          ClassName: values.Trayek?.MsClassName,
          PassengerTypeId: values.PassengerType?.Id,
          PassengerTypeName: values.PassengerType?.Name,
          OriginStationId: values.OriginTerminal?.MsStationId,
          OriginStationCode: values.OriginTerminal?.MsStationCode,
          OriginStationName: values.OriginTerminal?.MsStationName,
          OriginCityId: values.OriginTerminal?.MsCityId,
          OriginCityCode: values.OriginTerminal?.MsCityCode,
          OriginCityName: values.OriginTerminal?.MsCityName,
          DestinationStationId: values.DestinationTerminal?.MsStationId,
          DestinationStationCode: values.DestinationTerminal?.MsStationCode,
          DestinationStationName: values.DestinationTerminal?.MsStationName,
          DestinationCityId: values.DestinationTerminal?.MsCityId,
          DestinationCityCode: values.DestinationTerminal?.MsCityCode,
          DestinationCityName: values.DestinationTerminal?.MsCityName
        }]
      }
      if (isPp.value) {
        obj.BundleItemRoutes.push({
          TrayekId: values.Trayek?.Id,
          TrayekName: values.Trayek?.Name,
          RouteId: rit2Price.value?.MsRouteId,
          RouteName: rit2Price.value?.MsRouteName,
          // RouteDetails: values.Route?.RouteDetails,
          ClassId: values.Trayek?.MsClassId,
          ClassName: values.Trayek?.MsClassName,
          PassengerTypeId: values.PassengerType?.Id,
          PassengerTypeName: values.PassengerType?.Name,
          OriginStationId: values.DestinationTerminal?.MsStationId,
          OriginStationCode: values.DestinationTerminal?.MsStationCode,
          OriginStationName: values.DestinationTerminal?.MsStationName,
          OriginCityId: values.DestinationTerminal?.MsCityId,
          OriginCityCode: values.DestinationTerminal?.MsCityCode,
          OriginCityName: values.DestinationTerminal?.MsCityName,
          DestinationStationId: values.OriginTerminal?.MsStationId,
          DestinationStationCode: values.OriginTerminal?.MsStationCode,
          DestinationStationName: values.OriginTerminal?.MsStationName,
          DestinationCityId: values.OriginTerminal?.MsCityId,
          DestinationCityCode: values.OriginTerminal?.MsCityCode,
          DestinationCityName: values.OriginTerminal?.MsCityName
        })
      }
      emit('onSubmitAct', obj, index?.value)
      closeDialog()
    }
  }
}

const getTrayekDetail = async (data: any) => {
  await apiUseCase.get(`${trayekEndpoint}/${data.Id}`).then((response) => {
    const { error, result } = response
    if (!error) {
      trayekDetail.value = result
    }
  })
}

const checkPrice = async (origCityId: any, destCityId: any, routeId: any, passengerTypeId: any, ticketsSold: any, totalTicketPrice: any) => {
  // console.log('aaa')
  store.dispatch('showLoading')
  const params = {
    custom: [
      ['msPassengerId', '=', passengerTypeId],
      ['msRouteId', '=', routeId],
      ['originId', '=', origCityId],
      ['destinationId', '=', destCityId]
    ]
  }
  await apiUseCase.get(`${detailPriceEndpoint}/Search${returnUrlPrams(params)}`).then((response) => {
    // console.log('response', response.error)
    const { error, result, message } = response
    if (!error) {
      rit1Price.value = result
      // eslint-disable-next-line no-use-before-define
      countTempDiscount(ticketsSold, totalTicketPrice)
    } else {
      // console.log('xxx')
      $toast.add({
        severity: 'error',
        detail: 'Gagal mengambil data harga. Mohon periksa Master Harga atau hubungi Admin.',
        group: 'bc',
        closable: false,
        life: 3000
      })
      isLoadingDetail.value = true
    }
  })
  store.dispatch('hideLoading')
}

const usedRitId = ref([]) as any

const getRitData = async (passTypeId: any, routeId: any, origId: any, destId: any, routeList: any) => {
  // console.log('bbb')
  store.dispatch('showLoading')
  const params = {
    custom: [
      ['msPassengerId', '=', passTypeId],
      ['msRouteId', '=', routeId],
      ['originId', '=', origId],
      ['destinationId', '=', destId]
    ]
  }
  await apiUseCase.get(`${detailPriceEndpoint}/Search${returnUrlPrams(params)}`).then((response) => {
    const { error, result } = response
    if (!error) {
      rit2Price.value = result
      if (rit2Price.value) {
        isLoadingDetail.value = false
      } else {
        isPp.value = false
      }
    } else {
      // eslint-disable-next-line no-use-before-define
      getRit2(passTypeId, routeId, origId, destId, routeList)
    }
  })
  store.dispatch('hideLoading')
}

// eslint-disable-next-line consistent-return
const getRit2 = async (passTypeId: any, routeId: any, origId: any, destId: any, routeList: any) => {
  // console.log('usedRitId', usedRitId.value)
  if (!usedRitId.value.includes(routeId)) {
    usedRitId.value.push(routeId)
    const result = routeList.filter((item: any) => !usedRitId.value.includes(item.MsRouteId))
    // console.log('sadaa', result, rit2Price.value)
    if (result.length > 0 && !rit2Price.value) {
      await getRitData(passTypeId, result[0].MsRouteId, origId, destId, routeList)
    }
  }
}

const checkPrices = async (origCityId: any, destCityId: any, routeId: any, passengerTypeId: any, ticketsSold: any, totalTicketPrice: any) => {
  isLoadingDetail.value = true
  checkPrice(origCityId, destCityId, routeId, passengerTypeId, ticketsSold, totalTicketPrice)
  if (isPp.value) {
    // console.log('dasd')
    rit2Price.value = null
    usedRitId.value = []
    await getRit2(passengerTypeId, routeId, destCityId, origCityId, trayekDetail.value?.TrayekRoutes)
  } else {
    isLoadingDetail.value = false
  }
}

watch(rit2Price, (val: any) => {
  console.log('watch', [val, rit1Price.value, isPp.value])
  if ((val?.Bruto !== rit1Price.value?.Bruto) && isPp.value) {
    isPpPriceNotMatch.value = true
  } else {
    isPpPriceNotMatch.value = false
  }
})

watch(isPp, (val: any) => {
  // console.log('isPp', val)
  if (!val) {
    isPpPriceNotMatch.value = false
  }
})

const countTempDiscount = (qty: any, price: any) => {
  const originalPrice = rit1Price.value?.Bruto
  const newPrice = price
  totalOriginalPrice.value = qty * originalPrice
  tempDiscount.value = Math.round(((totalOriginalPrice.value - newPrice) / totalOriginalPrice.value) * 100)
}

const defineInitialValues = (data: any) => {
  initialValues.value.Id = data.Id
  initialValues.value.Name = data.DisplayName
  initialValues.value.TicketsSold = data.Quantity ?? 0
  initialValues.value.TotalTicketPrice = data.BundlePrice ?? 0
  totalOriginalPrice.value = data.OriginalPrice
  tempDiscount.value = data.TotalDiscount
  initialValues.value.Trayek = {
    Name: data.BundleItemRoutes[0].TrayekName,
    MsClassId: data.BundleItemRoutes[0].ClassId,
    MsClassName: data.BundleItemRoutes[0].ClassName,
    Id: data.BundleItemRoutes[0].TrayekId,
    label: data.BundleItemRoutes[0].TrayekName
  }
  initialValues.value.PassengerType = {
    Name: data.BundleItemRoutes[0].PassengerTypeName,
    Id: data.BundleItemRoutes[0].PassengerTypeId,
    label: data.BundleItemRoutes[0].PassengerTypeName,
  }
  initialValues.value.Route = {
    MsRouteName: data.BundleItemRoutes[0].RouteName,
    MsRouteId: data.BundleItemRoutes[0].RouteId,
    RouteDetails: trayekDetail.value.TrayekRoutes.filter((v: any) => v.MsRouteId === data.BundleItemRoutes[0].RouteId)[0].RouteDetails
  }
  initialValues.value.OriginTerminal = {
    MsStationCode: data.BundleItemRoutes[0].OriginStationCode,
    MsStationId: data.BundleItemRoutes[0].OriginStationId,
    MsStationName: data.BundleItemRoutes[0].OriginStationName,
    MsCityCode: data.BundleItemRoutes[0].OriginCityCode,
    MsCityId: data.BundleItemRoutes[0].OriginCityId,
    MsCityName: data.BundleItemRoutes[0].OriginCityName
  }
  initialValues.value.DestinationTerminal = {
    MsStationCode: data.BundleItemRoutes[0].DestinationStationCode,
    MsStationId: data.BundleItemRoutes[0].DestinationStationId,
    MsStationName: data.BundleItemRoutes[0].DestinationStationName,
    MsCityCode: data.BundleItemRoutes[0].DestinationCityCode,
    MsCityId: data.BundleItemRoutes[0].DestinationCityId,
    MsCityName: data.BundleItemRoutes[0].DestinationCityName
  }
  // trayekDetail.value = data.TrayekDetail
  rit1Price.value = {
    Bruto: data.OriginalPrice / data.Quantity,
    OriginCode: data.BundleItemRoutes[0].OriginStationCode,
    DestinationCode: data.BundleItemRoutes[0].DestinationStationCode
  }
  isPp.value = data.BundleItemRoutes.length > 1
  if (data.BundleItemRoutes.length > 1) {
    rit2Price.value = {
      Bruto: data.OriginalPrice / data.Quantity,
      OriginCode: data.BundleItemRoutes[1].OriginStationCode,
      DestinationCode: data.BundleItemRoutes[1].DestinationStationCode
    }
  }
  isLoadingDetail.value = false
  isLoading.value = false
}

const getItemData = async (data: any) => {
  isLoading.value = true
  // if (data?.Id) {
  //   await apiOpenUseCase.get(`${trayekEndpoint}/${idPrams.value.Id}/Items/${data.Id}`).then((response) => {
  //     console.log('response', response)
  //   })
  // }

  await getTrayekDetail({ Id: data.BundleItemRoutes[0].TrayekId })

  defineInitialValues(data)
}

onMounted(() => {
  console.log('asdadads', [index?.value, dataItem?.value, itemList?.value])
  if (route.params.id) {
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
  }
  if (dataItem?.value) {
    title.value = 'Edit'
    getItemData(dataItem.value)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Dialog), {
      class: "subscription-item-form",
      showHeader: true,
      visible: _unref(showModal),
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(showModal) ? (showModal).value = $event : null)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '75vw' },
      modal: true,
      contentClass: "wrap-ctn-modal-default"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(`${title.value} Item Paket`), 1),
          _createElementVNode("div", null, [
            _createElementVNode("i", {
              class: "pi pi-times cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog()))
            })
          ])
        ])
      ]),
      footer: _withCtx(() => []),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(Form), {
                    onSubmit: onSubmit,
                    "validation-schema": _unref(schema),
                    "initial-values": initialValues.value,
                    class: "form-container"
                  }, {
                    default: _withCtx(({ errors, setFieldValue, values }) => [
                      _createElementVNode("div", null, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_unref(Field), { name: "Name" }, {
                                default: _withCtx(({ field, handleChange, handleBlur }) => [
                                  _createVNode(_unref(InputText), _mergeProps(field, {
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    placeholder: "Masukkan nama item",
                                    autocomplete: "off"
                                  }), null, 16, ["onChange", "onBlur"])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_11, _toDisplayString(errors.Name), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_unref(Field), { name: "Trayek" }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(SelectAsync, _mergeProps(field, {
                                    placeholder: 'Pilih Trayek',
                                    modelValue: field.value,
                                    disabled: false,
                                    id: 'trayek',
                                    inputId: 'trayek',
                                    endpoint: "/management/v2/Trayeks",
                                    classname: 'custom-select',
                                    searchCustom: [['isActive', '=', true]],
                                    fieldLabel: (v) => `${v.Name}`,
                                    clearable: false,
                                    searchFields: ['q'],
                                    "onUpdate:modelValue": (v) => (getTrayekDetail(v), setFieldValue('Route', null), setFieldValue('PassengerType', null), setFieldValue('OriginTerminal', null), setFieldValue('DestinationTerminal', null), isPp.value = false, rit1Price.value = null, rit2Price.value = null)
                                  }), null, 16, ["modelValue", "fieldLabel", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_15, _toDisplayString(errors.Trayek), 1)
                            ])
                          ]),
                          (values.Trayek)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _hoisted_17,
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, _toDisplayString(values.Trayek?.MsClassName), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_unref(Field), { name: "Route" }, {
                                    default: _withCtx(({ }) => [
                                      _createVNode(_unref(Dropdown), {
                                        disabled: !values.Trayek,
                                        showClear: "",
                                        modelValue: values.Route,
                                        "onUpdate:modelValue": [($event: any) => ((values.Route) = $event), (v) => (setFieldValue('PassengerType', null), setFieldValue('OriginTerminal', null), setFieldValue('DestinationTerminal', null), isPp.value = false, rit1Price.value = null, rit2Price.value = null, usedRitId.value = [], isLoadingDetail.value = true)],
                                        options: _unref(trayekDetail)?.TrayekRoutes,
                                        optionLabel: (v) => `[RIT ${v.RitOrder}] ${v.MsRouteName}`,
                                        optionValue: (v) => ({ MsRouteName: v.MsRouteName, MsRouteId: v.MsRouteId, RouteDetails: v.RouteDetails }),
                                        placeholder: "Pilih Rute",
                                        class: "w-full"
                                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "options", "optionLabel", "optionValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _hoisted_26,
                                  _createVNode(_unref(InputSwitch), {
                                    modelValue: isPp.value,
                                    "onUpdate:modelValue": [
                                      _cache[1] || (_cache[1] = ($event: any) => ((isPp).value = $event)),
                                      (v) => values.PassengerType && values.OriginTerminal && values.DestinationTerminal ? (checkPrices(values.OriginTerminal?.MsStationId, values.DestinationTerminal?.MsStationId, values.Route?.MsRouteId, values.PassengerType.Id, values.TicketsSold, values.TotalTicketPrice), !v ? (rit2Price.value = null, usedRitId.value = [])  : '') : ''
                                    ]
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_27, _toDisplayString(errors.Route), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_unref(Field), { name: "PassengerType" }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(SelectAsync, _mergeProps(field, {
                                    placeholder: 'Pilih Jenis Penumpang',
                                    modelValue: field.value,
                                    disabled: !values.Route,
                                    id: 'passenger-type',
                                    inputId: 'passenger-type',
                                    endpoint: `/management/v1/MsRoute/${values.Route?.MsRouteId}/PassengerTypes`,
                                    classname: 'custom-select',
                                    searchCustom: [],
                                    "onUpdate:modelValue": () => values.PassengerType && values.OriginTerminal && values.DestinationTerminal ? checkPrices(values.OriginTerminal?.MsStationId, values.DestinationTerminal?.MsStationId, values.Route?.MsRouteId, values.PassengerType.Id, values.TicketsSold, values.TotalTicketPrice) : '',
                                    fieldLabel: (v) => `${v.Name}`,
                                    clearable: false,
                                    searchFields: []
                                  }), null, 16, ["modelValue", "disabled", "endpoint", "onUpdate:modelValue", "fieldLabel"])
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_31, _toDisplayString(errors.PassengerType), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createVNode(_unref(Field), { name: "OriginTerminal" }, {
                                    default: _withCtx(({  }) => [
                                      _createVNode(_unref(Dropdown), {
                                        disabled: !values.Route,
                                        showClear: "",
                                        modelValue: values.OriginTerminal,
                                        "onUpdate:modelValue": [($event: any) => ((values.OriginTerminal) = $event), () => values.PassengerType && values.OriginTerminal && values.DestinationTerminal ? checkPrices(values.OriginTerminal?.MsStationId, values.DestinationTerminal?.MsStationId, values.Route?.MsRouteId, values.PassengerType.Id, values.TicketsSold, values.TotalTicketPrice) : ''],
                                        options: values.Route?.RouteDetails,
                                        optionLabel: (v) => `[${v.MsStationCode}] ${v.MsStationName}`,
                                        optionValue: (v) => ({
                                MsStationCode: v.MsStationCode,
                                MsStationId: v.MsStationId,
                                MsStationName: v.MsStationName,
                                MsCityCode: v.MsCityCode,
                                MsCityId: v.MsCityId,
                                MsCityName: v.MsCityName
                              }),
                                        placeholder: "Pilih Kota Asal",
                                        class: "w-full"
                                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "options", "optionLabel", "optionValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", _hoisted_37, _toDisplayString(errors.OriginTerminal), 1)
                                ]),
                                _hoisted_38,
                                _createElementVNode("div", _hoisted_39, [
                                  _createVNode(_unref(Field), { name: "DestinationTerminal" }, {
                                    default: _withCtx(({  }) => [
                                      _createVNode(_unref(Dropdown), {
                                        disabled: !values.Route,
                                        showClear: "",
                                        modelValue: values.DestinationTerminal,
                                        "onUpdate:modelValue": [($event: any) => ((values.DestinationTerminal) = $event), () => values.PassengerType && values.OriginTerminal && values.DestinationTerminal ? checkPrices(values.OriginTerminal?.MsStationId, values.DestinationTerminal?.MsStationId, values.Route?.MsRouteId, values.PassengerType.Id, values.TicketsSold, values.TotalTicketPrice) : ''],
                                        options: values.Route?.RouteDetails,
                                        optionLabel: (v) => `[${v.MsStationCode}] ${v.MsStationName}`,
                                        optionValue: (v) => ({
                                MsStationCode: v.MsStationCode,
                                MsStationId: v.MsStationId,
                                MsStationName: v.MsStationName,
                                MsCityCode: v.MsCityCode,
                                MsCityId: v.MsCityId,
                                MsCityName: v.MsCityName
                              }),
                                        placeholder: "Pilih Kota Tujuan",
                                        class: "w-full"
                                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "options", "optionLabel", "optionValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", _hoisted_40, _toDisplayString(errors.DestinationTerminal), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_unref(Field), {
                                name: "TicketsSold",
                                class: _normalizeClass(`${errors.TicketsSold ? 'input-invalid' : ''}`)
                              }, {
                                default: _withCtx(({ }) => [
                                  _createElementVNode("div", _hoisted_44, [
                                    _createVNode(_unref(InputNumber), {
                                      modelValue: values.TicketsSold,
                                      "onUpdate:modelValue": ($event: any) => ((values.TicketsSold) = $event),
                                      class: _normalizeClass(`${errors.TicketsSold ? 'input-invalid' : ''}`),
                                      id: "TicketsSold",
                                      placeholder: "0",
                                      min: 0,
                                      currency: "IDR",
                                      locale: "id-ID",
                                      step: 0.25,
                                      inputId: "refund-amount",
                                      onInput: (v) => {
                            setFieldValue('TicketsSold', v.value)
                          },
                                      onBlur: ($event: any) => (countTempDiscount(values.TicketsSold, values.TotalTicketPrice)),
                                      allowEmpty: false,
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput", "onBlur"]),
                                    _hoisted_45
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["class"]),
                              _createElementVNode("div", _hoisted_46, _toDisplayString(errors.TicketsSold), 1)
                            ])
                          ])
                        ])
                      ]),
                      (!isLoadingDetail.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["p-2 rounded-lg border-grey-3 flex items-center", _unref(rit2Price) ? 'w-1/2' : 'w-full'])
                                }, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _hoisted_52,
                                    _createElementVNode("div", _hoisted_53, _toDisplayString(`${_unref(rit1Price) ? _unref(rit1Price).OriginCode : '-'} - ${_unref(rit1Price) ? _unref(rit1Price).DestinationCode : '-'}`), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _hoisted_55,
                                    _createElementVNode("div", _hoisted_56, _toDisplayString(`Harga normal: ${_unref(rupiahFormat)(_unref(rit1Price) ? _unref(rit1Price).Bruto : 0)}`), 1)
                                  ])
                                ], 2),
                                (_unref(rit2Price))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                      _createElementVNode("div", _hoisted_58, [
                                        _hoisted_59,
                                        _createElementVNode("div", _hoisted_60, _toDisplayString(`${_unref(rit2Price) ? _unref(rit2Price)?.OriginCode : '-'} - ${_unref(rit2Price) ? _unref(rit2Price)?.DestinationCode : '-'}`), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_61, [
                                        _hoisted_62,
                                        _createElementVNode("div", _hoisted_63, _toDisplayString(`Harga normal: ${_unref(rupiahFormat)(_unref(rit2Price) ? _unref(rit2Price)?.Bruto : 0)}`), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (isPpPriceNotMatch.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_64, "Harga tiket PP tidak sama"))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("div", _hoisted_67, _toDisplayString(`Harga Normal x Jumlah Karcis: ${_unref(rupiahFormat)((totalOriginalPrice.value ?? 0))}`), 1)
                                ]),
                                _createElementVNode("div", _hoisted_68, [
                                  _hoisted_69,
                                  _createVNode(_unref(Field), {
                                    name: "TotalTicketPrice",
                                    class: _normalizeClass(`${errors.TotalTicketPrice ? 'input-invalid' : ''}`)
                                  }, {
                                    default: _withCtx(({ meta }) => [
                                      _createElementVNode("div", _hoisted_70, [
                                        _createVNode(_unref(InputNumber), {
                                          modelValue: values.TotalTicketPrice,
                                          "onUpdate:modelValue": ($event: any) => ((values.TotalTicketPrice) = $event),
                                          class: _normalizeClass(`${errors.TotalTicketPrice ? 'input-invalid' : ''}`),
                                          id: "TotalTicketPrice",
                                          placeholder: "0",
                                          min: 0,
                                          currency: "IDR",
                                          locale: "id-ID",
                                          step: 0.25,
                                          inputId: "refund-amount",
                                          onInput: (v) => {
                            setFieldValue('TotalTicketPrice', v.value)
                          },
                                          onBlur: ($event: any) => (countTempDiscount(values.TicketsSold, values.TotalTicketPrice)),
                                          allowEmpty: false,
                                          autocomplete: "off"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput", "onBlur"]),
                                        _createElementVNode("span", _hoisted_71, _toDisplayString(`Diskon ${tempDiscount.value}%`), 1)
                                      ]),
                                      (meta.touched && !meta.valid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(errors.TotalTicketPrice), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_unref(Button), {
                          class: "btn-back mr-2",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (closeDialog()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_74
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Button), {
                          type: "submit",
                          class: "btn-primary mr-1"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_75
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["validation-schema", "initial-values"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})